var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllBackend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 100.8,
    height: 75.6,
    viewBox: "0 0 100.8 75.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.4 37.8L84 48.3L50.4 58.8L16.8 48.3L50.4 37.8Z",
    fill: "url(#paint0_linear_0_41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8 48.3L50.4 58.8V68.25L16.8 57.75V48.3Z",
    fill: "#93C5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.4 58.8L84 48.3V57.75L50.4 68.25V58.8Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.1 54.915C23.8539 54.915 24.465 54.3039 24.465 53.55C24.465 52.7961 23.8539 52.185 23.1 52.185C22.3461 52.185 21.735 52.7961 21.735 53.55C21.735 54.3039 22.3461 54.915 23.1 54.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.35 56.595C29.1039 56.595 29.715 55.9839 29.715 55.23C29.715 54.4761 29.1039 53.865 28.35 53.865C27.5961 53.865 26.985 54.4761 26.985 55.23C26.985 55.9839 27.5961 56.595 28.35 56.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.6 61.95L77.7 54.6",
    stroke: "#BFDBFE",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.4 23.1L84 33.6L50.4 44.1L16.8 33.6L50.4 23.1Z",
    fill: "url(#paint1_linear_0_41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.8 33.6L50.4 44.1V53.55L16.8 43.05V33.6Z",
    fill: "#93C5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.4 44.1L84 33.6V43.05L50.4 53.55V44.1Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.1 40.215C23.8539 40.215 24.465 39.6039 24.465 38.85C24.465 38.0961 23.8539 37.485 23.1 37.485C22.3461 37.485 21.735 38.0961 21.735 38.85C21.735 39.6039 22.3461 40.215 23.1 40.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.35 41.895C29.1039 41.895 29.715 41.2839 29.715 40.53C29.715 39.7761 29.1039 39.165 28.35 39.165C27.5961 39.165 26.985 39.7761 26.985 40.53C26.985 41.2839 27.5961 41.895 28.35 41.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M54.6 47.25L77.7 39.9",
    stroke: "#BFDBFE",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50.4 8.4L84 18.9L50.4 29.4L16.8 18.9L50.4 8.4Z",
    fill: "url(#paint2_linear_0_41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16.8 18.9L50.4 29.4V38.85L16.8 28.35V18.9Z",
    fill: "#93C5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M50.4 29.4L84 18.9V28.35L50.4 38.85V29.4Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M23.1 25.515C23.8539 25.515 24.465 24.9039 24.465 24.15C24.465 23.3961 23.8539 22.785 23.1 22.785C22.3461 22.785 21.735 23.3961 21.735 24.15C21.735 24.9039 22.3461 25.515 23.1 25.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M28.35 27.195C29.1039 27.195 29.715 26.5839 29.715 25.83C29.715 25.0761 29.1039 24.465 28.35 24.465C27.5961 24.465 26.985 25.0761 26.985 25.83C26.985 26.5839 27.5961 27.195 28.35 27.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M54.6 32.55L77.7 25.2",
    stroke: "#BFDBFE",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_41",
    x1: 16.8,
    y1: 37.8,
    x2: 28.7573,
    y2: 76.0633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_41",
    x1: 16.8,
    y1: 23.1,
    x2: 28.7573,
    y2: 61.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_41",
    x1: 16.8,
    y1: 8.4,
    x2: 28.7573,
    y2: 46.6633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDBFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllBackend);
export default __webpack_public_path__ + "static/media/ill-backend.cbc023bbdfca9f2ede1ce1b84fc572f3.svg";
export { ForwardRef as ReactComponent };